export default "__VITE_ASSET__zcUAAvmr__"